import React from "react";
import {RoleBadge} from "../../../../designSystem/components/RoleBadge";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons";

interface LogoutSectionProps {
  isCollapsed: boolean;
  userName: string;
  userRole: string;
  userOrganizationNames: string[];
  onClickLogout: () => void;
}

const LogoutSection = ({
  isCollapsed,
  userName,
  userRole,
  userOrganizationNames,
  onClickLogout,
}: LogoutSectionProps) => (
  <div>
    {!isCollapsed && userName &&
      <React.Fragment>
        <hr className="border-ptTeal-100"/>
        <div className={"flex flex-row justify-start items-center px-8 py-4 gap-x-4"}>
          <div className={"text-sm"}>
            <div className={"mb-2"}>
              <RoleBadge roleValue={userRole}/>
            </div>
            {userOrganizationNames.map((orgName, index) => (
              <div className={"text-gray-300"} key={index}>
                {orgName}
              </div>
            ))}
            <div className={"text-lg"}>
              {userName}
            </div>
          </div>
        </div>
        <hr className="mb-2 border-ptTeal-100"/>
      </React.Fragment>
    }
    <button
      onClick={onClickLogout}
      className="w-full flex items-center px-8 pt-2 pb-4 rounded  transition-all"
    >
      <FontAwesomeIcon icon={faSignOutAlt} className="text-xl"/>
      {!isCollapsed && <span className="ml-4">登出</span>}
    </button>
  </div>
)

export default LogoutSection;